import { Text, Icon } from '@zapier/design-system';
import clsx from 'clsx';
import React, { useRef } from 'react';
import { useButton } from 'react-aria';
import { Popover as Popover$1, Dialog } from 'react-aria-components';

const popover = "_popover_wo9mi_1";
const popoverContent = "_popover-content_wo9mi_18";
const dialog = "_dialog_wo9mi_34";
const closeButton = "_close-button_wo9mi_38";
const popoverHeaderLayout = "_popover-header-layout_wo9mi_49";
const popoverContentScrollContainer = "_popover-content-scroll-container_wo9mi_57";
const styles = {
	popover: popover,
	popoverContent: popoverContent,
	dialog: dialog,
	closeButton: closeButton,
	popoverHeaderLayout: popoverHeaderLayout,
	popoverContentScrollContainer: popoverContentScrollContainer
};

const Popover = ({ children, color = "dark", placement = "bottom", isOpen, onOpenChange, shouldCloseOnInteractOutside, triggerRef, title, className }) => {
  const ref = useRef(null);
  const { buttonProps } = useButton({ onPress: () => onOpenChange && onOpenChange(false) }, ref);
  return React.createElement(
    Popover$1,
    { className: clsx(styles.popover, className), "data-color": color, triggerRef, placement, shouldCloseOnInteractOutside, isOpen, onOpenChange },
    React.createElement(
      Dialog,
      { className: styles.dialog },
      React.createElement(
        Text,
        { type: "SmallPrint3", color: "GrayWarm1" },
        React.createElement(
          "div",
          { className: styles.popoverHeaderLayout },
          React.createElement(Text, { type: "SmallPrint2", color: color === "dark" ? "BrandLavender" : "UiPrimaryStronger", tag: "div" }, title),
          React.createElement(
            "button",
            Object.assign({ ref }, buttonProps, { className: styles.closeButton, type: "button" }),
            React.createElement(Icon, { isBlock: true, name: "formX", size: 16, color: color === "dark" ? "GrayWarm1" : "GrayWarm10" })
          )
        ),
        React.createElement(
          "div",
          { className: styles.popoverContentScrollContainer },
          React.createElement("div", { className: styles.popoverContent, "data-color": color }, children)
        )
      )
    )
  );
};

export { Popover };
//# sourceMappingURL=Popover.es.js.map
